/* tslint:disable */
/* eslint-disable */
/**
 * My App API
 * My App API description
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import {
    TeacherProfile,
    TeacherProfileFromJSON,
    TeacherProfileToJSON,
} from '../models';

/**
 * 
 */
export class AcceptorProfileApi extends runtime.BaseAPI {

    /**
     * プロフィール取得
     */
    async acceptorCurrentProfileRaw(): Promise<runtime.ApiResponse<TeacherProfile>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/api/professor/profile`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => TeacherProfileFromJSON(jsonValue));
    }

    /**
     * プロフィール取得
     */
    async acceptorCurrentProfile(): Promise<TeacherProfile> {
        const response = await this.acceptorCurrentProfileRaw();
        return await response.value();
    }

}
